import React, { useState } from 'react';
import styles from './VendorStoreMachineList.module.css';
import P from 'components/P';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import online from 'routes/vendor/storemanage/images/online.png';
import offline from 'routes/vendor/storemanage/images/offline.png';
import error from 'routes/vendor/storemanage/images/error.png';
import VendorMachineErrorModal from './commons/VendorMachineErrorModal';

// 스타일 변수
const fontSize = 'max(0.9vw, 10px)';

const VendorStoreMachineList = ({ machine }) => {
    const machineTypeText =
        machine.storeMachineType === 'kiosk' ? '키오스크' : '액상 자판기';

    let statusImage, statusText;
    switch (machine.storeMachineStatus) {
        case 'error':
            statusImage = error;
            statusText = '오류';
            break;
        case 'online':
            statusImage = online;
            statusText = '정상';
            break;
        case 'offline':
            statusImage = offline;
            statusText = '오프라인';
            break;
        default:
            statusImage = null;
            statusText = '';
            break;
    }

    // 모달 상태 관리
    const [isModalOpen, setIsModalOpen] = useState(false);

    // 모달 열기 함수
    const openModal = () => {
        setIsModalOpen(true);
    };

    // 모달 닫기 함수
    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <FlexChild>
            <VerticalFlex
                backgroundColor="white"
                padding="max(1vw, 10px)"
                borderRadius="1rem"
                gap="1rem"
            >
                <FlexChild>
                    <HorizontalFlex gap="1rem">
                        <FlexChild width="auto">
                            <div
                                className={
                                    machine.storeMachineType === 'kiosk'
                                        ? styles.kiosk
                                        : styles.vending
                                }
                            >
                                {machineTypeText}
                            </div>
                        </FlexChild>
                        <FlexChild>
                            <VerticalFlex gap="0.5rem">
                                <FlexChild alignItems="flex-start">
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <P
                                                size={fontSize}
                                                padding="0 0.5rem 0 0"
                                            >
                                                {machine.storeName}
                                            </P>
                                            <P size={fontSize}>
                                                {machineTypeText}
                                            </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild alignItems="flex-start">
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <img
                                                className={styles.status}
                                                src={statusImage}
                                                alt={statusText}
                                            />
                                            <span className={styles.statusText}>
                                                {statusText}
                                            </span>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                    <HorizontalFlex gap="1rem">
                        <FlexChild>
                            <div className={styles.buttonEnd}>시스템 종료</div>
                        </FlexChild>
                        <FlexChild>
                            <div className={styles.button}>시스템 시작</div>
                        </FlexChild>
                        <FlexChild>
                            <div className={styles.button} onClick={openModal}>
                                오류 관리
                            </div>
                            {/* 모달 컴포넌트 */}
                            {isModalOpen && (
                                <VendorMachineErrorModal
                                    machine={machine}
                                    callbackFn={closeModal}
                                />
                            )}
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
            </VerticalFlex>
        </FlexChild>
    );
};

export default VendorStoreMachineList;
